import React, { useContext } from "react";
import CredentialsContext from "../contexts/CredentialsContext";
import { Link, Navigate } from "react-router-dom";
import logoutUser from "../../js/utils/async/logoutUser";

import "../css/general.css";
import "../css/buttons.css";
import "./Header.css";

export function Header(props){
    const {credentials, setCredentials} = useContext(CredentialsContext);

    if(!credentials){
        return <Navigate to="/login"/>
    }

    let backMode = props.backMode ? props.backMode : "/dashboard";

    const logoutSubmit = async e => {
        e.preventDefault();
        await logoutUser();
        setCredentials();
        return <Navigate to="/login"/>
    }

    const userRoleTranslate = {
        user: "пользователь",
        expert: "эксперт",
        developer: "разработчик",
        admin: "администратор",
    }

    return(<div className="header-main">
        <div className="header-greetings">
            <div>{`Добро пожаловать, ${credentials.name}!`}</div>
            <div>{`Ваша роль: ${userRoleTranslate[credentials.role]}`}</div>
        </div>
        <div className="header-control">
            <Link className="btn btn-default btn-header" to={backMode}>Вернуться назад</Link>
            <Link className="btn btn-default btn-header" to="/dashboard">В панель управления</Link>
            <div onClick={logoutSubmit} className="btn btn-default btn-header">Выйти</div>
        </div>
    </div>);
}